import { removeNullishFromObjRecursive } from 'app/shared/utils/removeNullishFromObjRecursive.util';
import { Subscription, Observable } from 'rxjs';
import { EntityService } from './../../../services/entity.service';
import { Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { Location } from '@angular/common';
import { NgForm } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { AbstractDetailsComponent } from '../../shared/abstract-details.component';
import { Auction } from '../../../interfaces/auction';
import { AuctionDetailsGeneralComponent } from './auction-details-general.component';

@Component({
	selector: 'auction-details',
	templateUrl: './auction-details.component.html',
	styleUrls: ['./auction-details.component.scss']
})

export class AuctionDetailsComponent extends AbstractDetailsComponent implements OnInit, OnDestroy {

	@ViewChild('formRef', { static: true }) form: NgForm;
	@ViewChild(AuctionDetailsGeneralComponent, { static: true }) metadataComponent: AuctionDetailsGeneralComponent;

	entity: Auction;
	previewClipLength = '';
	relations: any = {};
	subscriptions = new Subscription();
	assignments: any = {};

	constructor(
		protected route: ActivatedRoute,
		protected location: Location,
		private entityService: EntityService
	) {

		super(route, location);
		this.entityConfiguration = {
			name: 'auction',
			entityType: 'auction',
			parentPath: '/adservices/auctions',
			basePath: '/adservices/auction/',
			versioned: true,
			showVersionMetadata: true,
			versionMetadataToSave: {
				bbcomment: ''
			},
			defaults: {
				status: 'active',
				name: '',
				subtype: 'prebid',
				prebidConfiguration: {
					__config__: {}
				}
			}
		};
	}

	ngOnInit() {
		super.ngOnInit();
		this.subscriptions.add(this.entityLoaded.subscribe(() => {
			this.sapiService.getUrl(`/auction/${ this.entity.id}/assignments`).subscribe((assignments) => {
				this.assignments = assignments;
			});
			this.relations = this.entityService.getRelations(this.entity);
		}));
	}

	ngOnDestroy() {
		this.subscriptions.unsubscribe();
	}

	save(force: boolean = false, extraHeaders?: any, saveDirectly: boolean = true, publish?: boolean): Observable<any> {
		if (this.entity?.prebidConfiguration) {
			removeNullishFromObjRecursive(this.entity.prebidConfiguration);
		}
		return super.save(force, extraHeaders, saveDirectly, publish);
	}
}
